// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'
import 'tuix-webcomponents/dist/assets/tuix-styles.css'
import 'tuix-webcomponents'
import { RootWrapper } from './src/components/RootWrapper/RootWrapper'
import {
    clearAnalyticsCookies,
    hasAnalyticsConsent,
    startGoogleTagManager,
} from './src/utils/cookieConsent'
import { scrollToHashWhenStable } from './src/utils/scrollToHash'

export const wrapRootElement = ({ element }) => <RootWrapper>{element}</RootWrapper>

export const shouldUpdateScroll = ({ routerProps: { location } }) => !location.hash

export const onRouteUpdate = ({ location }) => {
    if (location.hash) {
        scrollToHashWhenStable(location.hash)
    }

    if (hasAnalyticsConsent()) {
        startGoogleTagManager(location)
    } else {
        clearAnalyticsCookies()
    }
}
